import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import "date-fns";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// eslint-disable-next-line
import Container from '@material-ui/core/Container';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import { getSessionData } from "../../base/helper/baseHelper";
import SelectableSearch from "../../base/views/SelectableSearch";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import {
  getPhysicalInvenoryReportByDeadStock,
  getPhysicalInvenoryReportByExpiry, getPhysicalInvenoryReportByQty
} from "../helper/reportHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
      widht: "100%",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
}));

function PhysicalInventoryReportWithLotNo() {
  const classes = useStyles();

  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [fromDate, setFromDate] = React.useState(new Date());
  const [toDate, setToDate] = React.useState(new Date());
  const [gridData, setGridData] = React.useState([]);
  const [expireFilter, setExpireFilter] = React.useState("1");
  const [openMonths, setOpenMonths] = React.useState(false);
  const [openRadioButtons, setOpenRadioButtons] = React.useState(false);
  const [errors, setErrors] = React.useState({});
  const [filterData, setFilterData] = React.useState({
    load: false,
    values: [],
  });
  const [reportState, setReportState] = React.useState({
    user_id: userId,
    store_id: storeId,
    from_date: "",
    to_date: "",
    selectedFilter: { id: 0, optionname: "" },
    months: "0",
  });

  const validate = (fieldValues = reportState) => {
    let temp = { ...errors };

    if ("selectedFilter" in fieldValues) {
      temp.selectedFilter =
        fieldValues.selectedFilter.optionname === ""
          ? "Filter By is required"
          : "";
    }

    if (
      "selectedFilter" in fieldValues &&
      fieldValues.selectedFilter.id === 3 &&
      "months" in fieldValues &&
      openMonths
    ) {
      temp.months =
        fieldValues.months === "0" || fieldValues.months === ""
          ? "Months is required"
          : "";
    } else {
      temp.months = "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    // eslint-disable-next-line
  }, [userId, storeId]);

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const loadReport = (e) => {
    var fDate = new Date(fromDate);
    var strFromDate =
      fDate.getFullYear() +
      "/" +
      (fDate.getMonth() + 1) +
      "/" +
      fDate.getDate();

    var tDate = new Date(toDate);
    var strToDate =
      tDate.getFullYear() +
      "/" +
      (tDate.getMonth() + 1) +
      "/" +
      tDate.getDate();

    if (validate())
      if (reportState && reportState.selectedFilter.id === 1) {
        getPhysicalInvenoryReportByQty(storeId, userId, strFromDate, strToDate)
          .then((response) => {
            if (response && response.length > 0) {
              setGridData(response);
            } else {
              setGridData([]);
            }
          })
          .catch((err) => {});
      } else if (reportState && reportState.selectedFilter.id === 2) {
        getPhysicalInvenoryReportByDeadStock(
          storeId,
          userId,
          strFromDate,
          strToDate
        )
          .then((response) => {
            if (response && response.length > 0) {
              setGridData(response);
            } else {
              setGridData([]);
            }
          })
          .catch((err) => {});
      } else if (reportState && reportState.selectedFilter.id === 3) {
        var months;
        if (reportState.months === "") {
          months = "0";
        } else {
          months = reportState.months;
        }
        getPhysicalInvenoryReportByExpiry(
          storeId,
          userId,
          strFromDate,
          strToDate,
          months,
          expireFilter
        )
          .then((response) => {
            if (response && response.length > 0) {
              setGridData(response);
            } else {
              setGridData([]);
            }
          })
          .catch((err) => {});
      }
  };

  const loadReportOnEnter = (e) => {
    if (e.target.id === "months" && (e.type === "click" || e.which === 13)) {
      loadReport(e);
    }
  };

  const loadFilterDropdown = () => {
    setFilterData({ ...filterData, load: true });
    setFilterData({
      load: false,
      values: [
        { id: 1, optionname: "Qty" },
        { id: 2, optionname: "Dead Stock" },
        { id: 3, optionname: "Expiry" },
      ],
    });
  };

  const handleFilterChange = (event, value) => {
    setGridData([]);
    if (value && value.id) {
      if (value.id === 3) {
        setOpenRadioButtons(true);
      } else {
        setOpenRadioButtons(false);
        setOpenMonths(false);
        setExpireFilter("1");
      }
      setReportState({
        ...reportState,
        selectedFilter: { id: value.id, optionname: value.optionname },
      });
    } else {
      setReportState({
        ...reportState,
        selectedFilter: {},
      });
    }
  };

  const handleExpireFilter = (e) => {
    setGridData([]);
    setErrors({
      ...errors,
      months: "",
    });
    if (e.target.value && e.target.value === "1") {
      setOpenMonths(false);
    } else {
      setOpenMonths(true);
      setReportState({
        ...reportState,
        months: "",
      });
    }
    setExpireFilter(e.target.value);
  };

  const handleInputChange = (e) => {
    setReportState({
      ...reportState,
      months: e.target.value,
    });
  };

  return (
    <Container maxWidth={false}>
      
        <CssBaseline />
        <Grid container spacing={2} style={{ marginTop: "1.5%" }}>
          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid justify="space-around">
                <KeyboardDatePicker
                  autoFocus
                  margin="normal"
                  id="fromDate"
                  label="From Date"
                  format="MM/dd/yyyy"
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  value={fromDate}
                  onChange={handleFromDateChange}
                  className={classes.submit}
                  fullWidth
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid justify="space-around">
                <KeyboardDatePicker
                  margin="normal"
                  id="toDate"
                  label="To Date"
                  format="MM/dd/yyyy"
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  value={toDate}
                  onChange={handleToDateChange}
                  className={classes.submit}
                  fullWidth
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div style={{ paddingTop: 25 }}>
              <SelectableSearch
                value={reportState.selectedFilter}
                data={filterData}
                name="filter"
                label="Filter By"
                id="filter"
                loading={loadFilterDropdown}
                onChangeEvent={handleFilterChange}
                variantType="standard"
                {...(errors.selectedFilter && {
                  error: true,
                  helperText: errors.selectedFilter,
                })}
              ></SelectableSearch>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              onClick={(e) => {
                loadReport(e);
              }}
              fullWidth={true}
              color="primary"
              variant="contained"
              size="medium"
              style={{
                marginTop: "10%",
                backgroundColor: "rgb(22, 177, 255)",
                borderRadius: "0.5rem",
              }}
            >
              Generate
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          {openRadioButtons && (
            <Grid item xs={12} sm={6}>
              <RadioGroup
                row
                aria-label="scan"
                name="row-radio-buttons-group"
                value={expireFilter}
                onChange={handleExpireFilter}
                tabIndex={-1}
                style={{
                  border: "",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "80%",
                }}
              >
                <FormControlLabel
                  default
                  value="1"
                  control={<Radio />}
                  label="Expired"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="About to expire"
                />
                <FormControlLabel value="3" control={<Radio />} label="All" />
              </RadioGroup>
            </Grid>
          )}
          <Grid item xs={12} sm={3}>
            {openMonths && (
              <div onKeyDown={loadReportOnEnter}>
                <TextField
                  value={reportState.months}
                  onChange={handleInputChange}
                  type="number"
                  fullWidth
                  id="months"
                  label="Months"
                  name="months"
                  autoComplete="months"
                  autoFocus
                  {...(errors.months && {
                    error: true,
                    helperText: errors.months,
                  })}
                />
              </div>
            )}
          </Grid>
        </Grid>
        <div className={classes.root}>
          <MaterialTable
            title=""
            columns={[
              {
                title: "Description",
                field: "description",
                cellStyle: { width: "20%" },
              },
              { title: "Location", field: "location" },
              { title: "NDC", field: "ndc" },
              { title: "UPC", field: "upc" },
              { title: "Pack Size", field: "packsize" },
              { title: "Manufacturer", field: "manufacturer" },
              { title: "Lot #", field: "lot" },
              { title: "Exp Date", field: "expirationdate" },
              { title: "Full Qty", field: "fullquantity" },
              { title: "Partial Qty", field: "partialquantity" },
            ]}
            data={gridData}
            options={{
              rowStyle: (rowData) => {
                if (rowData.expiryflag === "1") {
                  return { backgroundColor: "#FFBF00" };
                } else if (rowData.expiryflag === "2") {
                  return { backgroundColor: "rgb(244, 67, 54)" };
                }

                return {};
              },
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
              exportButton: true,
              exportAllData: true,
            }}
          />
        </div>
        {/* </Container>
        </Container> */}
        <LandingPageFooter />
      
    </Container>
  );
}

const mapStateToDispatch = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(PhysicalInventoryReportWithLotNo);
